import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from 'react-router-dom'
import { Logger } from "../../utils/logger";

class Analytics extends Component {

  constructor(props) {
    super(props);
    Logger.init();
  }

  componentDidMount = () => {
    Logger.pageview();
  }

  componentWillReceiveProps = (nextProps) => {
    if( this.props.location.pathname != nextProps.location.pathname ){
      Logger.pageview();
    }
  }

  render = () => {
    return (
      <div/>
    );
  }
}
export default withRouter(Analytics);
